import { APP_NAME, COMMITMENT_LIST } from "../constants";
import socialImage1 from "../images/social/mission-1.jpg";
import socialImage2 from "../images/social/ig-social-2.webp";
import socialImage3 from "../images/social/mission-2.jpg";
import IconList from "./IconList";
import { motion } from "framer-motion";

const Mission = () => {
  const images = [socialImage1, socialImage2, socialImage3];
  return (
    <section id="mission">
      <div className="container p-5">
        <div className="bg-white mt-3">
          <div className="d-flex flex-column section-header">
            <h2 className="fw-bold">Mission</h2>
            <h4>We are committed to exceptional excellence </h4>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="mission-images-container mt-5">
                <div className="row justify-content-evenly">
                  {images.map((image, index) => (
                    <div className="col-md-12 col-lg-6" key={index}>
                      <img
                        src={image}
                        alt={`Mission-${index}`}
                        className="mission-images img-fluid"
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="mt-5 p-2">
                <motion.p
                  initial={{ opacity: 0, y: 50 }} // Start with text out of view (y: 50 moves it below the view)
                  whileInView={{ opacity: 1, y: 0 }} // Fade in and move up when in view
                  transition={{ duration: 0.6 }} // Duration of the animation
                  viewport={{ once: true }} // Ensures animation runs only once
                  className="texts"
                >
                  {APP_NAME} is committed to fostering a safer, more harmonious
                  community by providing exceptional dog training services and
                  raising well-behaved canine citizens. Our mission is to
                  partner with individuals, families, and organizations to:
                </motion.p>
                <IconList items={COMMITMENT_LIST} />
                <motion.p
                  initial={{ opacity: 0, y: 50 }} 
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }} 
                  className="texts"
                >
                  {APP_NAME} is driven by a passion for dogs and a commitment to
                  excellence. We brings a wealth of experience and dedication to
                  our mission, ensuring that we deliver the highest quality
                  training and service.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
